import { io, Socket } from "socket.io-client";
import {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
  ReactNode,
  FC,
} from "react";
import { useAuth } from "src/hooks/use-auth";

interface SocketContextType {
  socket: Socket | null;
  isConnected: boolean;
}

const SocketContext = createContext<SocketContextType>({
  socket: null,
  isConnected: false,
});

interface SocketProviderProps {
  children: ReactNode;
}

export const SocketProvider: FC<SocketProviderProps> = ({ children }) => {
  // const { isAuthenticated, user } = useAuth();
  // const [isConnected, setIsConnected] = useState(false);
  // const socketRef = useRef<Socket | null>(null);

  // useEffect(() => {
  //   // Only connect if user is authenticated
  //   if (!isAuthenticated || !user) {
  //     // Disconnect if user is not authenticated
  //     if (socketRef.current) {
  //       socketRef.current.disconnect();
  //       socketRef.current = null;
  //       setIsConnected(false);
  //     }
  //     return;
  //   }

  //   // Get the access token from localStorage
  //   const accessToken = localStorage.getItem("access_token");
  //   if (!accessToken) {
  //     console.warn("No access token found, cannot connect to socket");
  //     return;
  //   }

  //   // Get backend URL from environment
  //   const backendUrl = process.env.REACT_APP_BE_URL;
  //   if (!backendUrl) {
  //     console.error("REACT_APP_BE_URL is not defined");
  //     return;
  //   }

  //   // Create socket
  //   const socket = io(backendUrl, {
  //     auth: {
  //       token: accessToken,
  //     },
  //     transports: ["websocket", "polling"],
  //     reconnection: true,
  //     reconnectionDelay: 1000,
  //     reconnectionAttempts: 5,
  //   });

  //   socketRef.current = socket;

  //   // Handle connection events
  //   socket.on("connect", () => {
  //     console.log("Socket connected");
  //     setIsConnected(true);
  //   });

  //   socket.on("disconnect", () => {
  //     console.log("Socket disconnected");
  //     setIsConnected(false);
  //   });

  //   socket.on("connect_error", (error) => {
  //     console.error("Socket connection error:", error);
  //     setIsConnected(false);
  //   });

  //   // Cleanup on unmount or when auth state changes
  //   return () => {
  //     if (socket) {
  //       socket.disconnect();
  //       socketRef.current = null;
  //       setIsConnected(false);
  //     }
  //   };
  // }, [isAuthenticated, user]);

  return (
    <SocketContext.Provider
      value={{
        socket: null,
        isConnected: false,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = (): SocketContextType => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error("useSocket must be used within a SocketProvider");
  }
  return context;
};
